import React from 'react';
import PropTypes from 'prop-types';
import { Ban, Check, EyeOff, Link2, Plus } from 'lucide-react';
import { cn } from 'src/lib/utils';
import { SUGGEST_META } from './skillResolutionData';

// Same action → icon mapping as RecordDrawer's footer buttons/history rows
// (ACTION_ICONS there) — kept as a separate local map since that one also
// covers UNIGNORE/UNMAP, which never appear as a suggested_action.
const ACTION_ICONS = {
  MAP: Check,
  ALIAS: Link2,
  NEW_SKILL: Plus,
  IGNORE: EyeOff,
  BLOCK: Ban,
};

// The queue table and the record drawer both surface the API's
// suggested_action, but were each hand-rolling their own pill span with
// slightly different padding/sizing — this is the one definition both
// consume now, so the "suggested" pill looks the same wherever it appears.
// Matches the app's action-pill spec: 3px/9px padding, 6px radius, 11px/650
// type — not the fully-round "soft tonal" pill styling used for status.
const PILL_BASE =
  'inline-flex items-center gap-[5px] px-[9px] py-[3px] rounded-[6px] text-[11px] font-[650] tracking-[0.01em] whitespace-nowrap';

export function SuggestedActionPill({ action, showPrefix, className }) {
  const meta = action ? SUGGEST_META[action] : null;
  if (!meta) return null;
  const Icon = ACTION_ICONS[action];

  return (
    <span className={cn(PILL_BASE, meta.className, className)}>
      {Icon && (
        <Icon className="w-[12px] h-[12px] shrink-0" strokeWidth={2.6} />
      )}
      {showPrefix ? `Suggested: ${meta.label}` : meta.label}
    </span>
  );
}

SuggestedActionPill.propTypes = {
  action: PropTypes.string,
  showPrefix: PropTypes.bool,
  className: PropTypes.string,
};

SuggestedActionPill.defaultProps = {
  action: null,
  showPrefix: false,
  className: '',
};

export default SuggestedActionPill;
